import React from 'react'
import useDevices from '../hooks/useDevices'
import ListFoodContainer from './food/ListFoodContainer'
import ListFoodDesktop from './desktop'

const FoodDynamicDevice = () => {
    const { isMobile } = useDevices()

    return isMobile ? <ListFoodContainer /> : <ListFoodDesktop />
}

export default FoodDynamicDevice
